<div class="navPanel" id="navPanel" [ngClass]="isToShowNavPanel ? 'show-navPanel':'hide-navPanel'">
  <div class="overlay" *ngIf="isToShowMyAccountPanel"></div>
  <div class="myAccountPanel" *ngIf="isToShowMyAccountPanel" [ngClass]="windowType === 'mobile' ? 'mobile-menu':''">
    <ng-container [ngSwitch]="currentView">
      <app-app-cashier *ngSwitchCase="'CASHIER'" (triggerAccountMenu)="displayAccountMenu()"></app-app-cashier>
      <app-bonuses *ngSwitchCase="'BONUSES'" (triggerAccountMenu)="displayAccountMenu()"></app-bonuses>
      <app-complete-profile *ngSwitchCase="'MYACCOUNT'" (triggerAccountMenu)="displayAccountMenu($event)"></app-complete-profile>
      <app-update-profile *ngSwitchCase="'UPDATEPROFILE'" (triggerAccountMenu)="displayAccountMenu()"></app-update-profile>
      <app-change-password *ngSwitchCase="'CHANGEPASSWORD'" (triggerAccountMenu)="displayAccountMenu()"></app-change-password>
      <app-preference-center *ngSwitchCase="'PREFERENCE'" (triggerAccountMenu)="displayAccountMenu()"></app-preference-center>
      <app-transaction *ngSwitchCase="'TRANSACTIONS'" (triggerAccountMenu)="displayAccountMenu()"></app-transaction>
      <app-bet-history *ngSwitchCase="'BETHISTORY'" (triggerAccountMenu)="displayAccountMenu()"></app-bet-history>
    </ng-container>
  </div> 

  <div class="navPanel--container" id="navPanelToggle" #navPanelToggle [ngClass]="isToShowMyAccountPanel ? 'hide-navPanel':'show-navPanel'">
    <div class="overlay" *ngIf="isToShowNavPanel && !isToShowMyAccountPanel"></div>
    <div class="navPanel--content">
      
      <div class="logo-section">
        <h2 class="navPanel--content__title">{{ "navPanelComp.yourbrand" | translate }}</h2>
        <div class="logo-section--close" (click)="closeNavPanel()">&#x2715;</div>
        <!-- <a href="javascript:void(0)" class="logo-section--icon" routerLink="{{langCode+'/'}}">
          <img src="/assets/img/{{websiteName}}-left-logo.{{websiteLogoExtension}}" alt="{{websiteName}}.com logo" title="{{websiteName}}.com" />
        </a> -->
      </div>

      <!-- left panel dropdowns -->
      <div class="dropdown-section">

        <!-- Games dropdown -->
        <ul class="dropdown-section--list list__bottomgap">
          <li class="dropdown-section--listItem">
            <a routerLink="{{langCode+'/'}}">
              <span class="icon-item">
                <img class="unactive" width="21px" height="21px" src="{{siteUrlPath}}/{{mediaUrlPath}}/menu_icons/home.svg" />
                <img class="active" width="21px" height="21px" src="{{siteUrlPath}}/{{mediaUrlPath}}/menu_icons/home_active.svg" />
              </span>
              <span class="dropdown-section--listItemText">{{ "navPanelComp.home" | translate }}</span>
            </a>
          </li>
        </ul>
        <div class="dropdown-section--wrap">
          <button #casinoSelect class="dropdown-section--btn">
            <span class="icon-item">
              <img width="21px" height="21px" src="{{siteUrlPath}}/{{mediaUrlPath}}/menu_icons/casino.svg" />
            </span>
            <span class="dropdown-section--btnTxt">{{ "navPanelComp.casino" | translate }}</span>
            <i class="icon icon-nav-down-arrow"></i>
          </button>
          <app-lobby-tabs [lobbyDetails]="lobbyDetails" [fromNav]="true"></app-lobby-tabs>
        </div>

        <!-- Promotions dropdown -->
        <div class="dropdown-section--wrap">
          <button #promotionsSelect class="dropdown-section--btn">
            <span class="icon-item">
              <img width="21px" height="21px" src="{{siteUrlPath}}/{{mediaUrlPath}}/menu_icons/promotion.svg" />
            </span>
            <span class="dropdown-section--btnTxt">{{ "navPanelComp.promotions" | translate }}</span>
            <i class="icon icon-nav-down-arrow"></i>
          </button>
          <ul class="dropdown-section--list">
            <li class="dropdown-section--listItem" *ngFor="let specialPromo of specialPromotions">
              <a routerLink="{{langCode+'/'+specialPromo.url}}" (click)="closeSearch()">
                <span class="icon-item">
                  <img class="unactive" width="21px" height="21px"
                    src="{{siteUrlPath}}/{{mediaUrlPath}}/menu_icons/promotion_{{specialPromo.id}}.svg" />
                  <img class="active" width="21px" height="21px"
                    src="{{siteUrlPath}}/{{mediaUrlPath}}/menu_icons/promotion_{{specialPromo.id}}_active.svg" />
                </span>
                <span class="dropdown-section--listItemText">{{specialPromo.title}}</span>
              </a>
            </li>
            <li class="dropdown-section--listItem">
              <a routerLink="{{langCode+'/promotions'}}" (click)="closeSearch()">
                <span class="icon-item">
                  <img class="unactive" width="21px" height="21px"
                    src="{{siteUrlPath}}/{{mediaUrlPath}}/menu_icons/promotion_allpromotions.svg" />
                  <img class="active" width="21px" height="21px"
                    src="{{siteUrlPath}}/{{mediaUrlPath}}/menu_icons/promotion_allpromotions_active.svg" />
                </span>
                <span class="dropdown-section--listItemText">{{ "navPanelComp.allPromotions" | translate }}</span>
              </a>
            </li>
          </ul>
        </div>

        <!-- My Account dropdown -->
        <div class="dropdown-section--wrap" *ngIf="isUserLoggedIn">
          <button #myAccountSelect class="dropdown-section--btn">
            <span class="icon-item">
              <img width="21px" height="21px" src="{{siteUrlPath}}/{{mediaUrlPath}}/menu_icons/myAccountMain.svg" />
            </span>
            <span class="dropdown-section--btnTxt">{{ "navPanelComp.myAccount" | translate }}</span>
            <i class="icon icon-nav-down-arrow"></i>
          </button>
          <ul class="dropdown-menu">
            <ng-container>
              <li class="dropdown-section--listItem" *ngFor="let myaccountTab of myAccountTabs" [ngClass]= "(myaccountTab.id === 'withdrawls' && !totalPendingWithdrawalsAvailable)  ? 'hide': '' " >
                <a href="javascript:void(0)" (click)="myAccountDesktopNavigation(myaccountTab.name, myaccountTab.path)">
                  <span class="icon-item">
                    <img class="unactive" width="21px" height="21px"
                      src="{{siteUrlPath}}/{{mediaUrlPath}}/menu_icons/{{(myaccountTab.name).split('.')[1]}}.svg" />
                    <img class="active" width="21px" height="21px"
                      src="{{siteUrlPath}}/{{mediaUrlPath}}/menu_icons/{{(myaccountTab.name).split('.')[1]}}_active.svg" />
                  </span>
                  <span class="dropdown-section--listItemText">{{ myaccountTab.name | translate }}</span>
                  <span class="rewards_available" *ngIf="myaccountTab.name ==='profileSettingsComp.bonuses' && eligibleBonusLength">
                    {{'rewards.rewardsAvailable' | translate : {eligibleBonusLength:eligibleBonusLength} }}
                  </span>
                  <span class="rewards_available" *ngIf="myaccountTab.name ==='profileSettingsComp.withdrawals' && totalPendingWithdrawalsAvailable > 0">
                    {{'cashier.withdrawAvailable' | translate : {totalPendingWithdrawalsAvailable:totalPendingWithdrawalsAvailable} }}
                  </span>
                </a>
              </li>
            </ng-container>
            <!-- <ng-container *ngIf="windowType === 'mobile'">
              <li class="dropdown-section--listItem" *ngFor="let myaccountTab of myAccountTabsMobile"
                [ngClass]="(myaccountTab.id === 'withdrawls' && !totalPendingWithdrawalsAvailable)  ? 'hide': '' ">
                <a href="javascript:void(0)" (click)="myAccountMobileNavigation(myaccountTab.id)">
                  <span class="icon-item">
                    <img class="unactive" width="21px" height="21px"
                      src="{{siteUrlPath}}/{{mediaUrlPath}}/menu_icons/{{(myaccountTab.name).split('.')[1]}}.svg" />
                    <img class="active" width="21px" height="21px"
                      src="{{siteUrlPath}}/{{mediaUrlPath}}/menu_icons/{{(myaccountTab.name).split('.')[1]}}_active.svg" />
                  </span>
                  <span class="dropdown-section--listItemText">{{ myaccountTab.name | translate }}</span>
                  <span class="rewards_available"  *ngIf="myaccountTab.name ==='profileSettingsComp.bonuses' && eligibleBonusLength > 0">
                    {{'rewards.rewardsAvailable' | translate : {eligibleBonusLength:eligibleBonusLength} }}
                  </span>
                  <span class="rewards_available" *ngIf="myaccountTab.name ==='profileSettingsComp.withdrawals' && totalPendingWithdrawalsAvailable > 0">
                    {{'cashier.withdrawAvailable' | translate : {totalPendingWithdrawalsAvailable:totalPendingWithdrawalsAvailable} }}
                  </span>
                </a>
              </li>
            </ng-container> -->

          </ul>
        </div>
      </div>
    
      <div class="navPanel--chat">
        <i>
          <img src="{{siteUrlPath}}/{{mediaUrlPath}}/menu_icons/chat_icon.svg" />
        </i>
        <span>{{ "headerComp.needHelp" | translate }}</span>
        <h4 *ngIf="isZendeskEnabled">
          {{ "headerComp.liveSupport1" | translate }} <a
            (click)="toggleZDChat()">{{ "headerComp.liveSupport2" | translate }}</a>
        </h4>
      </div>

      <div *ngIf="checkUserLoginStatus()" class="timer-section show-below-992">
        <app-timer></app-timer>
      </div>
      <!-- left panel bottom buttons -->
      <!-- <div class="buttons-section hide-below-992">
          <a href="javascript:void(0)" class="leftPanel--btn" *ngIf="!isUserLoggedIn && isCountryAllowed === 1" (click)="moveToTrustlyPay()">
            <span>{{'payandplay.deposit' | translate}}</span>
          </a>
          <a href="{{'/'+langCode+'/register'}}" class="leftPanel--btn" *ngIf="!isUserLoggedIn && isCountryAllowed === 2" (click)="register($event)">
            <span>{{'headerComp.registerBtn' | translate}}</span>
          </a>
          <a href="javascript:void(0)" class="leftPanel--btn" *ngIf="isUserLoggedIn" (click)="deposit()">
            <span>{{'headerComp.depositBtn' | translate}}</span>
          </a>
      </div> -->

      <div class="userinfo_chat hide-below-992" [ngClass]="isToShowNavPanel ? 'show':'hide'">
        <ul>
          <li *ngIf="isZendeskEnabled">
            <a href="javascript:void(0)" (click)="toggleZDChat()">
              <!-- <img src="/assets/img/chat-icon.png"> -->
              {{ 'headerComp.liveChat' | translate }}
            </a>
          </li>
          <li>
            <a id="clock" class="clock"></a>
          </li>
        </ul>
      </div>

    </div>
  </div>
</div>